module.exports = __webpack_public_path__ + "img/BannerAcercaDe1920x300px.366348ab.jpg";